
import common from './en_US/common'
import areaCode from './en_US/areaCode'
import communicateCenter from './en_US/communicateCenter'
import components from './en_US/components'
import course from './en_US/course'
import courseDetail from './en_US/courseDetail'
import examDetail from './en_US/examDetail'
import home from './en_US/home'
import humanTraining from './en_US/humanTraining'
import inforList from './en_US/inforList'
import Information from './en_US/Information'
import intelligentOfficialDoc from './en_US/intelligentOfficialDoc'
import knowledgeLib from './en_US/knowledgeLib'
import LearnRecords from './en_US/LearnRecords'
import Login from './en_US/Login'
import myCourse from './en_US/myCourse'
import myExam from './en_US/myExam'
import mynews from './en_US/mynews'
import mySetting from './en_US/mySetting'
import mytopic from './en_US/mytopic'
import myTrainingClass from './en_US/myTrainingClass'
import myTrainingDetail from './en_US/myTrainingDetail'
import myWork from './en_US/myWork'
import post from './en_US/post'
import postDetail from './en_US/postDetail'
import practiceTrain from './en_US/practiceTrain'
import publicExam from './en_US/publicExam'
import questionnaire from './en_US/questionnaire'
import rules from './en_US/rules'
import search from './en_US/search'
import studyMap from './en_US/studyMap'
import topic from './en_US/topic'
import topicDetail from './en_US/topicDetail'
import topicManagerRange from './en_US/topicManagerRange'
import trainingClass from './en_US/trainingClass'
import trainingCourseDetail from './en_US/trainingCourseDetail'
import webLive from './en_US/webLive'

export default {
  ...common,
  ...areaCode,
  ...communicateCenter,
  ...components,
  ...course,
  ...courseDetail,
  ...examDetail,
  ...home,
  ...humanTraining,
  ...inforList,
  ...Information,
  ...intelligentOfficialDoc,
  ...knowledgeLib,
  ...LearnRecords,
  ...Login,
  ...myCourse,
  ...myExam,
  ...mynews,
  ...mySetting,
  ...mytopic,
  ...myTrainingClass,
  ...myTrainingDetail,
  ...myWork,
  ...post,
  ...postDetail,
  ...practiceTrain,
  ...publicExam,
  ...questionnaire,
  ...rules,
  ...search,
  ...studyMap,
  ...topic,
  ...topicDetail,
  ...topicManagerRange,
  ...trainingClass,
  ...trainingCourseDetail,
  ...webLive
}

